import React, { FC, useState, useEffect } from "react";
import { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { Button, message, Popover } from "antd";
import "./index.css";
import { exportPDF } from "@/utils/exportPDF";
import { useDtpDetailModel } from "../dtpDetailModel";
import { enquiryService } from "../../../dtpService";
import { IAuditPdf, IDtpDetail, IDtpMaterialDetail } from "../../../dtpTypes";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum4, formatNum, momentFormat } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
// import sealPng from "@/assets/images/seal.png"

export const CustomsClearance: FC<RouterParamType> = (detailsInfo) => {
    const {
        editFormVal, auditFields, setAuditFields
    } = useDtpDetailModel(({ auditFields, editFormVal }) => [auditFields, editFormVal]);
    const { getTreeNodeName } = useDictModel(() => []);

    const [ratify, setRatify] = useState<boolean>(false);   //是否开始审核
    const [loading, setLoading] = useState<boolean>(false);  //导出pdf， 导出时隐藏审批标记
    const [formVal, setFormVal] = useState<IDtpDetail | null>(null);
    const [list, setList] = useState<IDtpMaterialDetail[]>([])
    const [currency, setCurrency] = useState<string>("")  //币种符号

    useEffect(() => {
        getDtpDetailOne()
    }, [])

    //获取一条数据
    const getDtpDetailOne = async () => {
        let { retData } = await enquiryService.one(editFormVal.id);
        let { details, auditFlag, ...params } = retData;
        setFormVal(params)
        let newList = (details ?? []).map(item => ({
            ...item,
            // amount: formatNum(+(item.num ?? 0) * +(item.price ?? 0))
        }))
        setList(newList);
        setCurrency(details?.[0]?.currency ?? "")
        setAuditFields(auditFlag ? JSON.parse(auditFlag) : {});
    }

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            loading={loading}
            onClick={() => {
                setLoading(true);
                setTimeout(() => {
                    exportPDF("报关单", "customs-pdf", () => {
                        setLoading(false);
                    })
                }, 1500);
            }}
        >导出PDF</Button>
        <YhAuth resCode={ResourceAuthEnum.CUS_B_ED_REVIEW}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={editFormVal.status !== "clearance-status.to-Manager-audit"}
                onClick={() => {
                    message.success("已打开审核开关");
                    setRatify(true);
                }}
            >开始审核</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.CUS_B_ED_REVIEW1}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={!ratify}
                onClick={() => {
                    setAuditFields(origin => {
                        let obj: any = {
                            prescoCode: 1,          //         "预录入编号",
                            customsCode: 1,         //          "海关编号",
                            supplierName: 1,        //           "境内发货人",
                            exitType: 1,            //       "出境关别",
                            departureTime: 1,       //            "出口日期",
                            declareTime: 1,         //          "申报日期",
                            recordVarchar: 1,       //            "备案号",
                            customerName: 1,        //           "境内收货人",
                            shipmentType: 1,        //           "运输方式",
                            voyageNumber: 1,        //           "运输工具名称及航次号",
                            deliveryNumber: 1,      //             "提运单号",
                            supplierCode: 1,        //           "生产销售单位",
                            supervisionMethod: 1,   //                "监管方式",
                            exemptionType: 1,       //            "征免性质",
                            licenseKey: 1,          //         "许可证号",
                            saleCode: 1,                //   "合同协议号",
                            countryTrade: 1,        //           "贸易国",
                            destinationCountry: 1,  //                 "运抵国",
                            dischargingPort: 1,     //              "指运港",
                            portDeparture: 1,       //            "高境口岸",
                            packageType: 1,         //          "包装种类",
                            num: 1,                 //  "件数",
                            roughWeight: 1,         //          "毛重",
                            suttle: 1,              //     "净重",
                            transactionType: 1,     //              "成交方式",
                            freight: 1,             //      "运费",
                            premium: 1,             //      "保费",
                            incidentals: 1,         //          "杂费",
                            documentsNum: 1,        //           "随附单证及编号",
                            labelNote: 1,           //        "标记唛码及备注",
                        }
                        //商品详情每一个单元格审核
                        let detailsAudit = ["CustomsCode", "MaterialName", "Num", "Price", "OriginCountry", "DestinationCountry", "SourceSupply", "ShallBe"]
                        detailsAudit.forEach(auditItem => {
                            list.forEach(item => {
                                obj[item.id + auditItem as string] = 1
                            })
                        })
                        return obj
                    })
                    message.success("一键审核成功");
                }}
            >一键审核</Button>
        </YhAuth>
    </>



    const auditContent = (field: string) => (
        <>
            <div
                key="finish"
                style={{ padding: "0", margin: "0" }}
                className="label-span"
                onClick={() => {
                    setAuditFields(origin => ({ ...origin, [field]: 1 }))
                }}
            >√</div>
            <div
                key="close"
                style={{ padding: "0", margin: "0" }}
                className="label-span"
                onClick={() => {
                    setAuditFields(origin => ({ ...origin, [field]: 0 }))
                }}
            >×</div>
        </>
    );

    const classname = (type: 0 | 1 | undefined, str?: string) => {
        return 'c-audit' + (type === 1 ? ' c-li-finish ' : type === 0 ? ' c-li-close ' : " ") + (str ?? '')
    }
    const classnameTd = (type: 0 | 1 | undefined, str?: string) => {
        return 'c-audit' + (type === 1 ? ' c-td-finish ' : type === 0 ? ' c-td-close ' : " ") + (str ?? '')
    }
    const classnameGood = (type: 0 | 1 | undefined, str?: string) => {
        return 'c-audit' + (type === 1 ? ' c-goods-finish ' : type === 0 ? ' c-goods-close ' : " ") + (str ?? '')
    }

    return (
        <YhBox title={action} style={{ marginBottom: "75px" }} >
            {/* <div className="customs-pdf c-hover c-audit-flag" id="customs-pdf"> */}
            {formVal && <div className={`customs-pdf ${ratify ? "c-hover" : ''} ${loading ? "" : "c-audit-flag"}`} id="customs-pdf">
                <div className="c-header">
                    <span>中华人民共和国海关出口货物报关单</span>
                </div>
                <ul className="head-ul">
                    <Popover content={auditContent("prescoCode")} title="预录入编号" placement="topLeft" {...(ratify ? {} : { visible: false })}>
                        {/* <li className="w35 c-audit c-li-finish"> */}
                        <li className={classname(auditFields.prescoCode, "w35")}>
                            <span>预录入编号：</span>
                            {/* {formVal.prescoCode} */}
                        </li>
                    </Popover>
                    <Popover content={auditContent("customsCode")} title="海关编号" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                        <li className={classname(auditFields.customsCode, "w35")}><span>海关编号：</span>
                            {/* {formVal.customsCode} */}
                        </li>
                    </Popover>
                    <li></li>
                    <li></li>
                </ul>
                <table className="c-table">
                    <tbody>
                        <tr>
                            <Popover content={auditContent("supplierName")} title="境内发货人" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.supplierName)}>
                                    <b>境内发货人</b>({formVal.supplierCode})
                                    <br />
                                    <span>云湖春煜（天津）资产管理有限公司&nbsp;</span>
                                    {/* <span>{formVal.supplierName}&nbsp;</span> */}
                                </td>
                            </Popover>
                            <Popover content={auditContent("exitType")} title="出境关别" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.exitType)}>
                                    <b>出境关别</b>
                                    <br />
                                    <span>{formVal.exitType}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("departureTime")} title="出口日期" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.departureTime)}>
                                    <b>出口日期</b>
                                    <br />
                                    <span>{momentFormat(formVal.departureTime as string, "YYYY-MM-DD")}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("declareTime")} title="申报日期" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.declareTime)}>
                                    <b>申报日期</b>
                                    <br />
                                    <span>{momentFormat(formVal.declareTime as string, "YYYY-MM-DD")}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("recordVarchar")} title="备案号" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.recordVarchar)}>
                                    <b>备案号</b>
                                    <br />
                                    <span>{formVal.recordVarchar}&nbsp;</span>
                                </td>
                            </Popover>
                        </tr>
                        <tr>
                            <Popover content={auditContent("customerName")} title="境内收货人" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.customerName)}>
                                    <b>境外收货人</b>
                                    <br />
                                    <span>{formVal.customerName}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("shipmentType")} title="运输方式" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.shipmentType)}>
                                    <b>运输方式</b>
                                    <br />
                                    <span>{getTreeNodeName(formVal.shipmentType)}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("voyageNumber")} title="运输工具名称及航次号" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.voyageNumber)}>
                                    <b>运输工具名称及航次号</b>
                                    <br />
                                    <span>{formVal.voyageNumber}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("deliveryNumber")} title="提运单号" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={3} className={classnameTd(auditFields.deliveryNumber)}>
                                    <b>提运单号</b>
                                    <br />
                                    <span>{formVal.deliveryNumber}&nbsp;</span>
                                </td>
                            </Popover>
                        </tr>
                        <tr>
                            <Popover content={auditContent("supplierCode")} title="生产销售单位" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.supplierCode)}>
                                    <b>生产销售单位</b>({formVal.supplierCode})
                                    <br />
                                    <span>云湖春煜（天津）资产管理有限公司&nbsp;</span>
                                    {/* <span>{formVal.supplierName}&nbsp;</span> */}
                                </td>
                            </Popover>
                            <Popover content={auditContent("supervisionMethod")} title="监管方式" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.supervisionMethod)}>
                                    <b>监管方式</b>
                                    <br />
                                    <span>{getTreeNodeName(formVal.supervisionMethod)}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("exemptionType")} title="征免性质" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.exemptionType)}>
                                    <b>征免性质</b>
                                    <br />
                                    <span>{getTreeNodeName(formVal.exemptionType)}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("licenseKey")} title="许可证号" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={3} className={classnameTd(auditFields.licenseKey)}>
                                    <b>许可证号</b>
                                    <br />
                                    <span>{formVal.licenseKey}&nbsp;</span>
                                </td>
                            </Popover>
                        </tr>
                        <tr>
                            <Popover content={auditContent("saleCode")} title="合同协议号" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.saleCode)}>
                                    <b>合同协议号</b>
                                    <br />
                                    <span>{formVal.saleRealCode}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("countryTrade")} title="贸易国" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.countryTrade)}>
                                    <b>贸易国(地区)</b>
                                    <br />
                                    <span>{getTreeNodeName(formVal.countryTrade)}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("destinationCountry")} title="运抵国" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.destinationCountry)}>
                                    <b>运抵国(地区)</b>
                                    <br />
                                    <span>{getTreeNodeName(formVal.destinationCountry)}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("dischargingPort")} title="指运港" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={2} className={classnameTd(auditFields.dischargingPort)}>
                                    <b>指运港</b>
                                    <br />
                                    <span>{getTreeNodeName(formVal.dischargingPort)}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("portDeparture")} title="高境口岸" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.portDeparture)}>
                                    <b>离境口岸</b>
                                    <br />
                                    <span>{getTreeNodeName(formVal.portDeparture)}&nbsp;</span>
                                </td>
                            </Popover>
                        </tr>
                        <tr>
                            <Popover content={auditContent("packageType")} title="包装种类" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.packageType)}>
                                    <b>包装种类</b>
                                    <br />
                                    <span>{formVal.packageType}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("num")} title="件数" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.num)}>
                                    <b>件数</b>
                                    <br />
                                    <span>{formVal.num}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("roughWeight")} title="毛重" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.roughWeight)}>
                                    <b>毛重(千克)</b>
                                    <br />
                                    <span>{formVal.roughWeight}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("suttle")} title="净重" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.suttle)}>
                                    <b>净重(千克)</b>
                                    <br />
                                    <span>{formVal.suttle}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("transactionType")} title="成交方式" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.transactionType)}>
                                    <b>成交方式</b>
                                    <br />
                                    <span>{getTreeNodeName(formVal.transactionType)}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("freight")} title="运费" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.freight)}>
                                    <b>运费</b>
                                    <br />
                                    <span>{formVal.freight ? `${currency}/` : ""}{formVal.freight}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("premium")} title="保费" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.premium)}>
                                    <b>保费</b>
                                    <br />
                                    <span>{formVal.premium ? `${currency}/` : ""}{formVal.premium}&nbsp;</span>
                                </td>
                            </Popover>
                            <Popover content={auditContent("incidentals")} title="杂费" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td className={classnameTd(auditFields.incidentals)}>
                                    <b>杂费</b>
                                    <br />
                                    <span>{formVal.incidentals}&nbsp;</span>
                                </td>
                            </Popover>

                        </tr>
                        <tr>
                            <Popover content={auditContent("documentsNum")} title="随附单证及编号" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={9} className={classnameTd(auditFields.documentsNum)}>
                                    <b>随附单证及编号</b>
                                    <br />
                                    <span>{formVal.documentsNum}&nbsp;</span>
                                </td>
                            </Popover>
                        </tr>
                        <tr>
                            <Popover content={auditContent("labelNote")} title="标记唛码及备注" placement="topLeft" {...(ratify ? {} : { visible: false })} >
                                <td colSpan={9} className={classnameTd(auditFields.labelNote)} style={{ paddingBottom: "15px" }}>
                                    <b>标记唛码及备注</b>
                                    <br />
                                    <span>{formVal.labelNote}&nbsp;</span>
                                </td>
                            </Popover>
                        </tr>
                    </tbody>
                </table>
                <table className="cm-table">
                    <thead>
                        <tr>
                            <td>项号</td>
                            <td>商品编号</td>
                            <td>商品名称及规格型号</td>
                            <td>数量及单位</td>
                            <td>单价/总价/币制</td>
                            <td>原产国(地区)</td>
                            <td>最终目的国(地区)</td>
                            <td>境内货源地</td>
                            <td>征免</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            list && list.map((item, index) => (
                                <tr key={item.id} className="c-audit">
                                    <td>
                                        <span>{index + 1}</span>
                                        <br />
                                        <span>&nbsp;</span>
                                        <br />
                                        <span>&nbsp;</span>
                                    </td>
                                    <Popover content={auditContent(item.id + "CustomsCode" ?? "")} title={item.materialName + "【商品编号】"}  {...(ratify ? {} : { visible: false })}>
                                        <td className={classnameGood(auditFields[item.id + "CustomsCode" ?? ""])}>
                                            <span>{item.customsCode}</span>
                                            <br />
                                            <span>&nbsp;</span>
                                            <br />
                                            <span>&nbsp;</span>
                                        </td>
                                    </Popover>
                                    <Popover content={auditContent(item.id + "MaterialName" ?? "")} title={item.materialName + "【商品名称及规格型号】"}  {...(ratify ? {} : { visible: false })}>
                                        <td className={classnameGood(auditFields[item.id + "MaterialName" ?? ""])}>
                                            <span>{item.materialName}</span>
                                            <br />
                                            <span>{item.customsEntry ?? " "}</span>
                                            <br />
                                            <span>&nbsp;</span>
                                        </td>
                                    </Popover>
                                    <Popover content={auditContent(item.id + "Num" ?? "")} title={item.materialName + "【数量及单位】"}  {...(ratify ? {} : { visible: false })}>
                                        <td className={classnameGood(auditFields[item.id + "Num" ?? ""])}>
                                            <span>&nbsp;</span>
                                            <br />
                                            <span>{item.num}</span>
                                            <br />
                                            <span>{item.unitName}&nbsp;</span>
                                        </td>
                                    </Popover>
                                    <Popover content={auditContent(item.id + "Price" ?? "")} title={item.materialName + "【单价/总价/币制】"}  {...(ratify ? {} : { visible: false })}>
                                        <td className={classnameGood(auditFields[item.id + "Price" ?? ""])}>
                                            <span>{formatNum4(item.price)}</span>
                                            <br />
                                            <span>{formatNum(item.amount)}</span>
                                            <br />
                                            <span>{item.currency}</span>
                                        </td>
                                    </Popover>
                                    <Popover content={auditContent(item.id + "OriginCountry" ?? "")} title={item.materialName + "【原产国(地区)】"}  {...(ratify ? {} : { visible: false })}>

                                        <td className={classnameGood(auditFields[item.id + "OriginCountry" ?? ""])}>
                                            <span>{item.originCountry ?? " "}</span>
                                            <br />
                                            <span>&nbsp;</span>
                                            <br />
                                            <span>&nbsp;</span>
                                        </td>
                                    </Popover>
                                    <Popover content={auditContent(item.id + "DestinationCountry" ?? "")} title={item.materialName + "【最终目的国(地区)】"}  {...(ratify ? {} : { visible: false })}>

                                        <td className={classnameGood(auditFields[item.id + "DestinationCountry" ?? ""])}>
                                            <span>{item.destinationCountry ?? " "}</span>
                                            <br />
                                            <span>&nbsp;</span>
                                            <br />
                                            <span>&nbsp;</span>
                                        </td>
                                    </Popover>
                                    <Popover content={auditContent(item.id + "SourceSupply" ?? "")} title={item.materialName + "【境内货源地】"}  {...(ratify ? {} : { visible: false })}>
                                        <td className={classnameGood(auditFields[item.id + "SourceSupply" ?? ""])}>
                                            <span>{item.sourceSupply ?? " "}</span>
                                            <br />
                                            <span>&nbsp;</span>
                                            <br />
                                            <span>&nbsp;</span>
                                        </td>
                                    </Popover>
                                    <Popover content={auditContent(item.id + "ShallBe" ?? "")} title={item.materialName + "【征免】"}  {...(ratify ? {} : { visible: false })}>
                                        <td className={classnameGood(auditFields[item.id + "ShallBe" ?? ""])}>
                                            <span>{item.shallBe ?? " "}</span>
                                            <br />
                                            <span>&nbsp;</span>
                                            <br />
                                            <span>&nbsp;</span>
                                        </td>
                                    </Popover>
                                </tr>
                            ))
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={9}>
                                <Popover content={auditContent("relationshipAffirm")} title={"特殊关系确认"}  {...(ratify ? {} : { visible: false })}>
                                    <div className={classnameGood(auditFields.relationshipAffirm)}><b>特殊关系确认:</b>{formVal.relationshipAffirm}</div>
                                </Popover>
                                <Popover content={auditContent("priceAffirm")} title={"价格影响确认"}  {...(ratify ? {} : { visible: false })}>
                                    <div className={classnameGood(auditFields.priceAffirm)}><b>价格影响确认:</b>{formVal.priceAffirm}</div>
                                </Popover>
                                <Popover content={auditContent("payAffirm")} title={"支付特许权使用费确认"}  {...(ratify ? {} : { visible: false })}>
                                    <div className={classnameGood(auditFields.payAffirm)}><b>支付特许权使用费确认:</b>{formVal.payAffirm}</div>
                                </Popover>
                                {/* <div><b>公式定价确认:</b></div>
                                <div><b>暂定价格确认:</b></div> */}
                                <Popover content={auditContent("declareType")} title={"自报自缴"}  {...(ratify ? {} : { visible: false })}>
                                    <div className={classnameGood(auditFields.declareType)}><b>自报自缴:</b>{formVal.declareType}</div>
                                </Popover>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={6}>
                                <div>
                                    <span><b>报关人员</b></span>
                                    <span><b>报关人员证号</b></span>
                                    <span><b>电话</b></span>
                                    <span><b>兹申明对以上内容承担如实申报、依法纳税之法律责任</b></span>
                                </div>
                                <div style={{ position: "relative" }}>
                                    {formVal.status === "clearance-status.effect" && <div className="seal-box"></div>}
                                    <span><b>申报单位</b></span>
                                    <span><b>申报单位(签章)</b></span>
                                </div>
                            </td>
                            <td colSpan={3}>
                                <b>海关批注及签章</b>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>}
        </YhBox >
    )
}